import TablaConciliacion from "../../../TablaConciliacion";

function TablaAltviales() {
  return <TablaConciliacion nombreUseCase="ALTERNATIVASVIALES" titulo="ALTERNATIVAS VIALES" />;
}

export default TablaAltviales;
